import React, { useState, useEffect, useRef } from "react"
import { withPrefix } from "gatsby"
import Layout from "../components/layout"
import Page from "../components/page"
import Hero from "../components/hero"
import Image from "../components/image"
import { PageColumns, Column } from "../components/page-column"
import DownloadFullReport from "../components/download-full-report"
import downloadTranslations from "../data/download-translations.json"
import menu from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Helmet } from "react-helmet"

export default function Downloads({ language }) {
  const textRef = useRef()
  const [languageRTL, setLanguageRTL] = useState(false)
  const [translation, setTranslation] = useState(
    findObject(downloadTranslations, "language", "en") // Default to English
  )

  const downloadResources = findObject(
    menu,
    "name",
    "Downloads"
  ).children.filter(child => child.name !== "Download Full Report")

  useEffect(() => {
    let validTranslation = findObject(
      downloadTranslations,
      "language",
      language
    )

    if (validTranslation) {
      setTranslation(validTranslation)
      setLanguageRTL(validTranslation.language === "ar")
    }

    textRef.current.innerHTML = translation.text
  }, [language, translation])

  return (
    <Layout>
      <Helmet>
        <html lang={translation.language} />
      </Helmet>

      <Hero
        title={translation.header}
        classes={languageRTL ? "util__rtl" : ""}
        basic
      />

      <Page classes={`downloads ${languageRTL ? "util__rtl" : ""}`}>
        <PageColumns align="center">
          <Column location="right">
            <div className="downloads__report">
              <a
                href={withPrefix("/") + translation.download.href}
                className="downloads__report__image-link"
              >
                <Image
                  path={translation.download.image}
                  alt={translation.download.alt}
                />
              </a>
              <a
                className="cta cta--primary"
                href={withPrefix("/") + translation.download.href}
              >
                {translation.download.cta}
              </a>
            </div>
          </Column>

          <Column>
            <div className="text-block" ref={textRef} />
          </Column>
        </PageColumns>

        <PageColumns modifiers="downloads__resources">
          <Column>
            <h2 className="h2 util__text-centered">{translation.resources}</h2>

            {downloadResources && (
              <div className="downloads__resources__list">
                <ul>
                  {downloadResources.map((item, index) => (
                    <li key={`download-resources-${index}`}>
                      <a
                        className="title title--xs title--bold"
                        href={withPrefix("/") + item.href}
                      >
                        {translation[item.name]}
                      </a>
                    </li>
                  ))}

                  {/* Manually include Photo Credits */}
                  <li>
                    <a
                      className="title title--xs title--bold"
                      href={withPrefix("/") + "downloads/photo-credits.pdf"}
                    >
                      {translation["Photo Credits"]}
                    </a>
                  </li>
                </ul>
              </div>
            )}

            <DownloadFullReport
              location="page"
              title={translation.download_the_pdf_report}
              title_size="s"
            />
          </Column>
        </PageColumns>
      </Page>
    </Layout>
  )
}
